import { render, staticRenderFns } from "./covid_upload.vue?vue&type=template&id=0730e788&"
import script from "./covid_upload.vue?vue&type=script&lang=js&"
export * from "./covid_upload.vue?vue&type=script&lang=js&"
import style0 from "./covid_upload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports